// extracted by mini-css-extract-plugin
module.exports = {"icon":"_102eDO","disabled":"IQ0w_8","title":"_13cOja","mdIcon":"_2OYycA","smIcon":"_1UhhN7"};